<template>
  <div>
    <div
      id="modifyDataModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">修改電子簽單</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <h4>1. 司機輸入金額</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="price"
                :disabled="invoiceId !== null || driverWithdrawal !== null"
              />
            </div>
            <div class="row">
              <h4>2. 上車地點</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="onAddress"
              />
            </div>
            <div class="row">
              <h4>3. 下車地點</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="offAddress"
              />
            </div>
            <div class="row">
              <h4>4. 簽單備註</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="signingNote"
              />
            </div>
            <div class="row">
              <h4>5. 車隊服務費</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="serviceFee"
              />
            </div>
            <div class="row">
              <h4>6. 客服備註</h4>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="serviceNote"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="updateSigningInfo"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'

export default {
  data() {
    return {
      onAddress: '',
      offAddress: '',
      signingNote: '',
      enterpriseSignId: '',
      price: 0,
      serviceNote: '',
      serviceFee: 0,
      driverWithdrawal: null,
      invoiceId: null,
    }
  },
  methods: {
    showModal() {
      $('#modifyDataModal').modal('show')
    },
    setValues(payload) {
      this.onAddress = payload.onAddress
      this.offAddress = payload.offAddress
      this.signingNote = payload.signingNote
      this.serviceFee = payload.serviceFee
      this.serviceNote = payload.serviceNote
      this.enterpriseSignId = payload.enterpriseSignId
      this.price = payload.price
      this.driverWithdrawal = payload.driverWithdrawal
      this.invoiceId = payload.invoiceId

      this.showModal()
    },
    updateSigningInfo() {
      let payload = {
        onAddress: this.onAddress,
        offAddress: this.offAddress,
        serviceNote: this.serviceNote,
        serviceFee: this.serviceFee,
        note: this.signingNote,
        price: parseInt(this.price),
      }
      EnterpriseAPI.put(
        `enterprise/signinginfo/?id=${this.enterpriseSignId}`,
        payload,
      )
        .then((res) => {
          if (!res.success) return alert(res.result)
          this.$msg('修改成功')
          this.$emit('getSigningList', '')
          $('#modifyDataModal').modal('hide')
        })
        .catch((err) => {
          this.$msg('修改失敗，請再試一次')
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/company/ModifyDataModal.vue